import api from './api';

const API_PREFIX = '/api';

export interface DoctorSearchResult {
  DoctorID: number;
  DoctorFirstName: string;
  DoctorLastName: string;
  CPSO?: string;
  DoctorFax?: string;
  DoctorPhone?: string;
  DoctorAddress?: string;
  DoctorCity?: string;
  DoctorProvince?: string;
  DoctorPostal?: string;
}

const doctorService = {
  async searchDoctors(
    pharmacyId: string,
    params: { firstName?: string; lastName?: string; cpso?: string } = {},
  ): Promise<DoctorSearchResult[]> {
    const response = await api.get(`${API_PREFIX}/doctor/search`, {
      params: { pharmacyId, ...params },
    });
    return response.data;
  },

  async getDoctorsForPatient(
    pharmacyId: string,
    patientId: string,
  ): Promise<DoctorSearchResult[]> {
    const response = await api.get(`${API_PREFIX}/doctor/by-patient`, {
      params: { pharmacyId, patientId },
    });
    return response.data;
  },
};

export default doctorService;
